import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_CHATTER_PROGRAM_ATTENDANCE, MANAGE_CHATTER_PROGRAM_ATTENDANCE_LIST, MANAGE_CHATTER_PROGRAM_EDIT, MANAGE_CHATTER_PROGRAM_LIST, MANAGE_CHATTER_PROGRAM_REMOVE_LESSON, MANAGE_CHATTER_PROGRAM_VIEW } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const chatterProgramApi = createApi({
    reducerPath: 'chatterProgramApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/chatter/program",
    }),
    tagTypes: ["ChatterProgramList", "ChatterProgramDetails", "ChatterProgramAttendanceList", "ChatterProgramAttendanceDetails"],
    endpoints: (builder) => ({

        // chatter program list
        getChatterProgramList: builder.query({
            query: ({ search = "", status = "", start_date = null, end_date = null, page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_CHATTER_PROGRAM_LIST,
                    data: { search, page, limit, sort, status, start_date, end_date }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterProgramList"]
        }),

        // chatter program details
        getChatterProgramDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_CHATTER_PROGRAM_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterProgramDetails"]
        }),

        // remove assigned chatter lesson
        removeAssignedLesson: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_CHATTER_PROGRAM_REMOVE_LESSON}/${id}`
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        // update chatter program
        updateChatterProgram: builder.mutation({
            query: ({ data, programId }) => ({
                method: "PUT",
                url: `${MANAGE_CHATTER_PROGRAM_EDIT}/${programId}`,
                data
            }),
            invalidatesTags: ["ChatterProgramList", "ChatterProgramDetails"]
        }),

        // mark attendance
        markAttendance: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MANAGE_CHATTER_PROGRAM_ATTENDANCE}/${id}`,
                data
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        // chatter program attendance list
        getChatterProgramAttendanceList: builder.query({
            query: ({ program_id = "", location_type = "", search = "", client_type = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_CHATTER_PROGRAM_ATTENDANCE_LIST,
                    data: { program_id, location_type, search, page, limit, sort, status, client_type: client_type?.value }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterProgramAttendanceList"]
        }),

        // chatter program details
        getChatterProgramAttendanceDetails: builder.query({
            query: (id) => {
                return ({
                    method: "PATCH",
                    url: `${MANAGE_CHATTER_PROGRAM_ATTENDANCE_LIST}/${id}`
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterProgramAttendanceDetails"]
        })
    }),
})

export const {
    useGetChatterProgramListQuery,
    useGetChatterProgramDetailsQuery,
    useRemoveAssignedLessonMutation,
    useUpdateChatterProgramMutation,
    useMarkAttendanceMutation,
    useGetChatterProgramAttendanceListQuery,
    useGetChatterProgramAttendanceDetailsQuery

} = chatterProgramApi;